<div class="time-container">
  @if (!(hideRedundant && !days)) {
    <div class="time-item">
      <span class="time-field">
        <mb-countdown-time [time]="days" [class.three-digits-days]="(days + '').length === 3"></mb-countdown-time>
      </span>
      <span class="time-label">{{ (days === 1 ? 'DAY' : 'DAYS') | translate }}</span>
    </div>
  }
  @if (!(hideRedundant && !hours)) {
    <div class="time-item">
      <span class="time-field"><mb-countdown-time [time]="hours"></mb-countdown-time></span>
      <span class="time-label">{{ 'SHORT_HOURS' | translate }}</span>
    </div>
  }
  @if (!(hideRedundant && !minutes)) {
    <div class="time-item">
      <span class="time-field"><mb-countdown-time [time]="minutes"></mb-countdown-time></span>
      <span class="time-label">{{ 'SHORT_MINUTES' | translate }}</span>
    </div>
  }
  @if (!(hideRedundant && !seconds)) {
    <div class="time-item">
      <span class="time-field"><mb-countdown-time [time]="seconds"></mb-countdown-time></span>
      <span class="time-label">{{ 'SHORT_SECONDS' | translate }}</span>
    </div>
  }
</div>
